import React from "react";
import {FormGroup, Label, Input, FormFeedback} from 'reactstrap';

const CheckboxGroup = ({id, name, description, value, options, onChange, onCheckboxChange, terms, required, errors}) => {
    const needsColumns = options.length > 6;
    const splitAfterIndex = Math.round(options.length / 2);
    const checkItems = options.map((option, index) => {
        return (
            <FormGroup check key={`checkbox-option-${option.id}`} className="mb-2">
                <Label check
                       className={`${!!errors ? ' is-invalid ' : ' '}`}
                >
                    <Input
                        type="checkbox"
                        name={option.name}
                        onChange={e => {
                            onCheckboxChange(id, name, option.id, !!e.target.checked)
                        }}
                    />{" "}
                    <span className="d-inline-block ml-2" dangerouslySetInnerHTML={{__html: option.description}}/>
                </Label>
            </FormGroup>
        );
    });

    if(needsColumns) {
        return (
            <div className="row">
                <div className="col-md-4 mb-2 pr-md-1">
                    {description} {!!required && '*'}
                </div>
                <div className="col-md-8 mb-2">
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup className="mb-0">
                                {checkItems.slice(0, splitAfterIndex)}
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup className="mb-0">
                                {checkItems.slice(splitAfterIndex)}
                            </FormGroup>
                        </div>
                    </div>
                    {!!errors ? <FormFeedback className="d-block mt-0 mb-2">{errors[0]}</FormFeedback> : ''}
                </div>
            </div>
        )
    }

    return (
        <div className="row">
            <div className="col-md-4 mb-2 pr-md-1">
                {description} {!!required && '*'}
            </div>
            <div className="col">
                {checkItems}
                {!!errors ? <FormFeedback className="d-block mt-0 mb-2">{errors[0]}</FormFeedback> : ''}
            </div>
        </div>
    );
};

export default CheckboxGroup;
